module.exports = __webpack_public_path__ + "static/media/ShimeiHe.d122f0ee.jpg";